import React from "react";
import Arrow from "../../assets/backArrow.png"; // आपकी arrow icon image
import pickupbyotp from '../../assets/pickupbyotp.png'
import swipe from '../../assets/swipe.png'
import gonext from "../../assets/gonext.png"; 
import  './pickup.css';
import Header from "./Header";
import { useNavigate, useParams } from "react-router-dom";

/* import Header from "./Header" */;

const PickupOptions = () => {

  const navigate=useNavigate()
    const { orderId } = useParams()

  const handleKioskPickup = () => {
    //console.log("Navigate to Kiosk Pickup Screen");
     navigate(`/activeOrder/false/${orderId}`)
  };

  const handleAppPickup = () => {
    //console.log("Navigate to App Swipe Screen");
    navigate(`/`)
    //navigate("/pickup/app")
  };

  const handleSwipe=()=>{
    navigate(`/activeOrder/true/${orderId}`)
  }

  return (

   <div>
   <Header handleBack={handleAppPickup}/> 
      
    
         <div style={{     padding:"5%",    borderRadius: "20px",paddingTop:"20vw"}}>

 
      {/* Subtitle */}
      <p className="subtitle">
        2 Pickup Options – Choose What Works Best For You
      </p>

      {/* First Card */}
      <div style={{    
      "box-shadow":"0 2px 6px rgb(0 0 0 / 33%)" ,padding:"5%",    borderRadius: "20px"}}  onClick={handleKioskPickup}>

      
      <div className="card">
        <img
          src={pickupbyotp}
          alt="kiosk pickup"
          className="card-img"
        />
       
      </div>
       <div className="card-footer">
          <span>Vend By Entering Code On Kiosk</span>
          <img src={gonext} alt="arrow" className="arrow" />
        </div>
</div>
      {/* OR Divider */}
          <div className="divider-container">
      <span className="divider-line"></span>
      <span className="divider-text">OR</span>
      <span className="divider-line"></span>
    </div>

      {/* Second Card */}
          <div style={{    
      "box-shadow":"0 2px 6px rgb(0 0 0 / 33%)" ,padding:"5%",    borderRadius: "20px"}} onClick={handleSwipe}>

      
      <div className="card" >
        <img
          src={swipe}
          alt="kiosk pickup"
          className="card-img"
        />
       
      </div>
       <div className="card-footer">
          <span>Vend By Swiping On App</span>
          <img src={gonext} alt="arrow" className="arrow" />
        </div>
</div>
    </div>
    </div>
  );
};

export default PickupOptions;
